import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import pushButton from '../../images/button_push.png';
import buttonUnlocked from '../../images/button_unlocked.gif';
import buttonlocked from '../../images/button_locked.gif';
import iconFolder from '../../images/icon_folder.gif';
import fileIcon from '../../images/icon_file.gif';
import renameButton from '../../images/button_rename.gif';
import button_unzip from '../../images/button_unzip.gif';
import Header from '../common/Header/Header';
import Footer from '../common/Footer/Footer';
import Banner from '../common/Banner/Banner';
import apiService from "../utils/apiService";
import _ from 'lodash';
import '../common/css/pw_push5.css';
import {
  getSubDirectories, pushfile, getFileSMSInfo, emptySMSInfo, noDirOrUserFound, deleteFilesAction,
  downloadBulkFilesInZip
} from './actions';
import Loader from "../common/Loader";
import Modal from 'react-modal';
import SmsPopup from '../common/Modal/SMS/SmsPopup';
import Unzip from '../common/Modal/Unzip/Unzip';
import NoUserDir from '../common/Modal/NoUserDir';
import { updateGenricSuccessMessageToEmpty } from '../User/actions';
import RenameFolder from '../common/Modal/RenameFolder';
import { MS_CONSOLE_TITLE } from '../utils/Constants';
import {
  getCurrentPathFromLocation,
  buildMediaChildPath,
  toPreviewPath,
  appendAppQuery,
} from '../utils/pathUtils';
import { DELETED_ITEMS_API, RESTORE_FILE_API } from '../../Constants';
import DeleteFolder from '../common/Modal/DeleteFolder';
import RestoreItemsModal from '../common/Modal/RestoreItemsModal';
import {
  safeGetLocalStorage,
  safeGetSessionStorage,
  safeSetSessionStorage
} from '../utils/storageUtils';
import {
  DASHBOARD_OWNERSHIP_SESSION_KEY,
  buildDashboardOwnershipRowKey,
  formatDashboardOwnership,
  isDashboardOwnershipRole
} from './dashboardOwnershipUtils';
import useDashboardOwnership from './useDashboardOwnership';

const shouldDisableCheckboxForPath = (currentPath) => {
  if (currentPath === '/') {
    return true;
  }
  const splitCurrentPath = currentPath.split('/').filter((path) => path !== '');
  return splitCurrentPath.length === 1 && splitCurrentPath[0] === 'ov2';
};

const formatDelTs = (ts) => {
  if (!ts) return '';
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return String(ts);
  }
};

const applyRestoreResponse = async (body, { loadDeletedItems, dispatch, currentPath }) => {
  if (body?.status_code === 200) {
    await loadDeletedItems();
    dispatch(getSubDirectories({ dir: currentPath }));
    const failed = body?.data?.failed;
    if (Array.isArray(failed) && failed.length > 0) {
      const msg = failed.map((f) => `${f.itemId}: ${f.message || 'failed'}`).join('\n');
      window.alert(`Some items could not be restored:\n${msg}`);
    }
    const restored = body?.data?.restored;
    const livePushed = body?.data?.livePushed;
    const livePushFailed = body?.data?.livePushFailed;
    const notes = Array.isArray(body?.data?.notifications) ? body.data.notifications : [];
    if (Array.isArray(livePushed) && livePushed.length > 0) {
      window.alert(`Restored and pushed to live:\n${livePushed.join('\n')}`);
    } else if (Array.isArray(livePushFailed) && livePushFailed.length > 0) {
      const msg = livePushFailed
        .map((f) => `${f.name}: ${f.reason || 'failed'}`)
        .join('\n');
      window.alert(`Restored on auth, but live push failed:\n${msg}`);
    } else if (notes.length > 0) {
      window.alert(notes.join('\n'));
    } else if (Array.isArray(restored) && restored.length > 0) {
      window.alert(`Restored: ${restored.join(', ')}`);
    }
    return;
  }
  window.alert(body?.message || 'Restore failed');
};

const Dashboard = ({ }) => {
  const [filesLists, setFilesList] = useState([]);
  const msTitle = `${MS_CONSOLE_TITLE} Environment - Media Delivery Console`;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardRole = safeGetLocalStorage('user.role');
  const canManageDashboardOwnership = isDashboardOwnershipRole(dashboardRole);

  const [loading, setLoading] = useState(false);
  const [indexing, setIndexing] = useState({});
  const [showOwnershipDetails, setShowOwnershipDetails] = useState(
    () =>
      canManageDashboardOwnership
      && safeGetSessionStorage(DASHBOARD_OWNERSHIP_SESSION_KEY) === 'true'
  );

  // UI state
  const [disableCheckbox, setDisableCheckbox] = useState(true);
  const [selectedFile, setSelectedFile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedFileToUnzip, setSelectedFileToUnzip] = useState(null);
  const [showUnzipPopup, setShowUnzipPopup] = useState(false);
  const [noUserDirStatus, setNoUserDirStatus] = useState(false);
  const [noUserDirResp, setNoUserDirResp] = useState([]);
  const [dirCount, setDirCount] = useState(0);
  const [deleteFilesArray, setDeleteFilesArray] = useState([]);
  const [showRenamePopup, setShowRenamePopup] = useState(false);
  const [selectedFileToRename, setSelectedFileToRename] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filesToDelete, setFilesToDelete] = useState([]);
  const [result, setResult] = useState(null);
  const [showDeletedView, setShowDeletedView] = useState(false);
  const [deletedItems, setDeletedItems] = useState([]);
  const [deletedItemsLoading, setDeletedItemsLoading] = useState(false);
  const [selectedDeletedIds, setSelectedDeletedIds] = useState([]);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [deletedItemsToRestore, setDeletedItemsToRestore] = useState([]);
  const isSuperAdmin = dashboardRole === 'Super Admin';
  const isVendor = dashboardRole === 'Vendor';


  const buildPath = (parent, child) => {
    const p = String(parent || '').replace(/^\/+/, '').replace(/\/+$/, '');
    const c = String(child || '').replace(/^\/+/, '');
    if (!p) {
      return c;
    }
    return `${p}/${c}`;
  };


  // --- Index API (row-scoped loading) ---
  const fileindex = async (pathToIndex) => {
    setResult(null);
    setIndexing(prev => ({ ...prev, [pathToIndex]: true }));

    const INDEX_API = 'index';
    try {
      const response = await apiService.post(INDEX_API, { path: pathToIndex });
      const data = _.get(response, "data", {});
      setResult(data);
      return data;
    } catch (error) {
      const errorData = {
        message: { info: "Indexing failed or unauthorized" },
        success: false,
      };
      setResult(errorData);
      return errorData;
    } finally {
      setIndexing(prev => ({ ...prev, [pathToIndex]: false }));
    }
  };

  // --- Path handling ---
  const currentPath = getCurrentPathFromLocation(location.pathname);

  const {
    isOwnershipEligible,
    ownershipByPath,
    ownershipLoading,
    ownershipError,
    ownershipTruncated
  } = useDashboardOwnership({
    role: dashboardRole,
    enabled: showOwnershipDetails,
    currentPath,
    showDeletedView,
    listingReady: !loading && Array.isArray(filesLists),
    directoryItems: filesLists
  });
  const ownershipColumnCount = isOwnershipEligible ? 2 : 0;
  const mainTableColSpan = 8 + Number(isSuperAdmin) + ownershipColumnCount;

  const handleOwnershipPreferenceChange = (event) => {
    const enabled = Boolean(event.target.checked);
    setShowOwnershipDetails(enabled);
    safeSetSessionStorage(DASHBOARD_OWNERSHIP_SESSION_KEY, String(enabled));
  };

  // --- Redux selectors ---
  const directoriesList = useSelector(state => { return state.directoriesReducer.serverResponse });
  const noDirUserInfo = useSelector(state => { return state.directoriesReducer.noUserDirInfo });

  // Cache directory names
  let directorieslistarray = [];
  if (directoriesList) {
    directorieslistarray = directoriesList.data.map(item => item.directory);
  }
  localStorage.setItem('directories', directorieslistarray);

  // No user/dir access handling
  useEffect(() => {
    if (noDirUserInfo?.status_code === 404 && noDirUserInfo?.status === 'Failed') {
      setNoUserDirResp(noDirUserInfo);
      setNoUserDirStatus(true);
      setDisableCheckbox(true);
    }
  }, [noDirUserInfo]);

  useEffect(() => {
    const t = setTimeout(() => {
      dispatch(updateGenricSuccessMessageToEmpty({}));
    }, 5000);

    setFilesList(directoriesList?.data);
    setDirCount(directoriesList?.data?.length);
    deSelectAllFiles();
    setLoading(false);

    return () => clearTimeout(t);
  }, [directoriesList, dispatch]);

  const rootFolderClickHandler = (path, isFile) => {
    setLoading(true);
    if (isFile) {
      setLoading(false);
      window.open(toPreviewPath(location.pathname, path));
    } else {
      setFilesList([]);
      navigate(buildMediaChildPath(location.pathname, path));
    }
  };

  // Detect path changes (back/forward) and toggle global controls
  useEffect(() => {
    setLoading(true);
    setDisableCheckbox(shouldDisableCheckboxForPath(currentPath));
  }, [currentPath, dispatch]);

  const pushSubmit = async (fileName) => {
    if (window.confirm("Are you sure you want push file(s) live?")) {
      const payload = {
        file: fileName,
        current_path: currentPath,
        update: 1
      };
      dispatch(pushfile({ payload }));
      scrollToTop();
    }
  };

  const closeSMSModalPopup = useCallback((popupState) => {
    setIsPopupOpen(!popupState);
    dispatch(getSubDirectories({ dir: currentPath }));
  }, [currentPath, dispatch]);

  const closeNoUserDirModalPopup = useCallback((popupState) => {
    setNoUserDirStatus(!popupState);
    dispatch(noDirOrUserFound({}));
  }, [dispatch]);

  const unzipcustomStyles = {
    content: {
      height: '300px',
      top: '-15%',
    },
  };


  // const previewcustomStyles = {
  //   content: {
  //    height:'450px',
  //    top: '0%',
  //   },
  // };
  const closeUnzipModalPopup = (popupState) => {
    setShowUnzipPopup(!popupState);
    setTimeout(() => {
      dispatch(getSubDirectories({ dir: currentPath }));
    }, 2000);
  };

  const displaySMSPopupModal = (filepath) => {
    setSelectedFile(filepath);
    setIsPopupOpen(true);
    dispatch(emptySMSInfo({}));
    dispatch(getFileSMSInfo({ current_path: currentPath, sms_file: filepath }));
    navigate(appendAppQuery(location.pathname, 'sms_config'));
  };

  const displayUnzipPopupModal = (filepath) => {
    setSelectedFileToUnzip(filepath);
    setShowUnzipPopup(true);
    navigate(appendAppQuery(location.pathname, 'unzip'));
  };

  const displayRenamePopupModal = (filepath) => {
    setSelectedFileToRename(filepath);
    setShowRenamePopup(true);
    navigate(appendAppQuery(location.pathname, 'rename'));
  };

  const closeRenameFolderModalPopup = (popupState) => {
    setShowRenamePopup(!popupState);
    dispatch(getSubDirectories({ dir: currentPath }));
    scrollToTop();
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const customStyles = {
    content: {
      height: '250px',
      top: '-25%',
    },
  };

  const previewcustomStyles = {
    content: {
      height: '450px',
      top: '0%',
    },
  };

  let directoriesListDelete = [];
  if (directoriesList) {
    directoriesListDelete = directoriesList.data.map(item => ({
      directory: item.directory,
      isFile: item.isFile
    }));
  }
  localStorage.setItem('directoriesListDelete', JSON.stringify(directoriesListDelete));

  const deleteFiles = (e) => {
    if (e.target.checked) {
      setDeleteFilesArray(prev => [...prev, e.target.value]);
    } else {
      setDeleteFilesArray(prev => prev.filter(file => file !== e.target.value));
    }
  };

  const selectAllFiles = (e) => {
    let checkboxArray = document.getElementsByName("fileDelete[]");
    let fileArray = [];
    checkboxArray.forEach((file) => { file.checked = true; fileArray.push(file.value); });
    setDeleteFilesArray(prev => {
      const set = new Set([...prev, ...fileArray]);
      return Array.from(set);
    });
  };

  const deSelectAllFiles = (e) => {
    let checkboxArray = document.getElementsByName("fileDelete[]");
    checkboxArray.forEach((file) => { file.checked = false; });
    setDeleteFilesArray([]);
  };

  const deleteSelectedFiles = (e) => {
    e.preventDefault();
    if (deleteFilesArray.length > 0) {
      setFilesToDelete(deleteFilesArray);
      setShowDeleteModal(true);
    } else {
      alert('Please Select Files to delete');
    }
  };

  const confirmDelete = () => {
    dispatch(deleteFilesAction({ data: { current_path: currentPath, files: filesToDelete } }));
    setDeleteFilesArray([]);
    setShowDeleteModal(false);
    scrollToTop();
  };

  useEffect(() => {
    if (!showDeleteModal) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [showDeleteModal]);

  /** Match restore spec body: `pegasus` (no leading slash); root → '' */
  const currentPathForRestoreApi =
    currentPath === '/' ? '' : String(currentPath).replace(/^\/+/, '');

  const loadDeletedItems = useCallback(async () => {
    setDeletedItemsLoading(true);
    try {
      const res = await apiService.post(DELETED_ITEMS_API, { current_path: currentPath });
      const body = res?.data;
      if (body?.status_code === 200 && Array.isArray(body.data)) {
        setDeletedItems(body.data);
      } else {
        setDeletedItems([]);
      }
    } catch {
      setDeletedItems([]);
    } finally {
      setDeletedItemsLoading(false);
    }
  }, [currentPath]);

  useEffect(() => {
    if (showDeletedView) {
      loadDeletedItems();
    }
  }, [showDeletedView, loadDeletedItems]);

  useEffect(() => {
    setShowDeletedView(false);
  }, [currentPath]);

  // Clear file selection when switching between views
  useEffect(() => {
    if (showDeletedView) {
      deSelectAllFiles(); // Clear selection when entering deleted view
    }
  }, [showDeletedView]);

  useEffect(() => {
    setSelectedDeletedIds([]);
  }, [deletedItems]);

  const toggleDeletedRowSelect = (itemId) => {
    if (!itemId) return;
    setSelectedDeletedIds((prev) =>
      prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
    );
  };

  const selectAllDeleted = () => {
    const ids = deletedItems.map((r) => r._id).filter(Boolean);
    if (ids.length === 0) return;
    setSelectedDeletedIds(ids);
  };

  const clearAllDeleted = () => {
    setSelectedDeletedIds([]);
  };

  const applyRestoreResponseForDashboard = async (body) => {
    await applyRestoreResponse(body, { loadDeletedItems, dispatch, currentPath });
  };

  const restoreSelectedDeleted = async () => {
    if (selectedDeletedIds.length === 0) {
      window.alert('Select one or more items to restore.');
      return;
    }

    const selectedRows = deletedItems.filter((item) => selectedDeletedIds.includes(item._id));
    const selectedRestoreItems = selectedRows.map((item) => ({
      fileName: item.originalName,
      isFile: item.itemType === 'file',
    }));
    setDeletedItemsToRestore(selectedRestoreItems);
    setShowRestoreModal(true);
  };

  const confirmRestore = async () => {
    if (selectedDeletedIds.length === 0) {
      setShowRestoreModal(false);
      return;
    }
    const res = await apiService.post(RESTORE_FILE_API, {
      current_path: currentPathForRestoreApi,
      item_ids: selectedDeletedIds,
    });
    await applyRestoreResponseForDashboard(res?.data);
    setShowRestoreModal(false);
  };

  return (
    <>
      <Header title={msTitle} />
      <body>
        <Banner
          title={msTitle}
          currentPath={currentPath}
          disableCheckbox={disableCheckbox}
          dirListCount={dirCount}
          hideSearch={showDeletedView}
        />
        <br />
        {canManageDashboardOwnership && currentPath === '/' && (
          <div className="dashboard-ownership-toggle">
            <label htmlFor="dashboard-show-ownership-details">
              <input
                id="dashboard-show-ownership-details"
                type="checkbox"
                checked={showOwnershipDetails}
                onChange={handleOwnershipPreferenceChange}
              />
              <span>Show Ownership Details</span>
            </label>
          </div>
        )}
        <div className='generalcoursecontainer'>
          {showDeletedView ? (
            <>
             <div className="soft-delete-back-wrap">
                <button
                  type="button"
                  className="btn-back-to-folder-green"
                  onClick={() => {
                    deSelectAllFiles(); // Clear any lingering selection
                    setShowDeletedView(false);
                  }}
                >
                   Back to Previous folder
                </button>
              </div>
              <div className="soft-delete-view-toolbar">
                <p className="soft-delete-view-heading">Soft-deleted items in this folder</p>
              </div>
             
              <table className='myTable soft-delete-items-table' border="1" width="99%" cellSpacing="1" cellPadding="2">
                <thead>
                  <tr align="left" valign="top">
                    <th align="center" valign="middle" width="56" scope="col">
                      <div className="soft-delete-select-th">Select</div>
                    </th>
                    <th align="center" valign="middle" width="50" scope="col">SMS</th>
                    <th align="left" valign="middle" scope="col">&nbsp;Name</th>
                    <th align="left" valign="middle" width="100" scope="col">&nbsp;Size (Bytes)</th>
                    <th align="left" valign="middle" width="140" scope="col">&nbsp;Deleted at</th>
                    <th align="left" valign="middle" width="140" scope="col">&nbsp;Expires</th>
                    <th align="left" valign="middle" width="120" scope="col">&nbsp;Deleted by</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedItemsLoading ? (
                    <tr><td colSpan="7"><Loader /></td></tr>
                  ) : (
                    deletedItems.length > 0 ? (
                      deletedItems.map((row, index) => {
                        const cellStyle = index % 2 === 0 ? 'cellWhite' : 'cellGreen';
                        const isFile = row.itemType === 'file';
                        const folderIcon = isFile ? fileIcon : iconFolder;
                        const smsEnabled = row.enable_sms_protection === 'Enabled';
                        const rowId = row._id;
                        return (
                          <tr align="left" valign="top" key={row._id || index}>
                            <td width="56" className={'checkboxalign ' + cellStyle}>
                              <input
                                type="checkbox"
                                checked={rowId ? selectedDeletedIds.includes(rowId) : false}
                                onChange={() => toggleDeletedRowSelect(rowId)}
                                disabled={!rowId}
                                aria-label={`Select ${row.originalName || 'item'} for restore`}
                              />
                            </td>
                            <td width="50" className={'checkboxalign ' + cellStyle}>
                              <img
                                alt=""
                                className="soft-delete-sms-icon"
                                src={smsEnabled ? buttonlocked : buttonUnlocked}
                                title={smsEnabled ? 'SMS protection enabled' : 'SMS protection disabled'}
                              />
                            </td>
                            <td className={cellStyle} nowrap="">
                              &nbsp;<img alt="" src={folderIcon} />&nbsp;{row.originalName}
                            </td>
                            <td className={cellStyle}>{row.sizeInBytes}</td>
                            <td className={'checkboxalign ' + cellStyle}>{formatDelTs(row.deletedAt)}</td>
                            <td className={'checkboxalign ' + cellStyle}>{formatDelTs(row.expiresAt)}</td>
                            <td className={cellStyle}>{row.deletedBy}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr><td colSpan="7" className="cellWhite">No soft-deleted items in this folder.</td></tr>
                    )
                  )}
                </tbody>
              </table>
              {!deletedItemsLoading && deletedItems.length > 0 ? (
                <>
                  <table role="presentation" width="100%">
                    <tbody>
                      <tr align="left" valign="top">
                        <td align="left">
                          <button
                            type="button"
                            className="cellWhite formButtonGo delete-selected"
                            onClick={selectAllDeleted}
                          >
                            Select&nbsp;All
                          </button>
                          <span className="cellWhite">&nbsp;|&nbsp;</span>
                          <button
                            type="button"
                            className="cellWhite formButtonGo delete-selected"
                            onClick={clearAllDeleted}
                            disabled={selectedDeletedIds.length === 0}
                          >
                            Clear&nbsp;All
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="soft-delete-bulk-actions">
                    <button
                      type="button"
                      className="btn-restore-green btn-restore-selected"
                      disabled={selectedDeletedIds.length === 0}
                      onClick={restoreSelectedDeleted}
                    >
                      Restore
                    </button>
                  </div>
                </>
              ) : null}
            </>
          ) : (
            <>
              {ownershipError && (
                <div className="dashboard-ownership-message" role="status">
                  Content ownership lookup is unavailable.
                </div>
              )}
              {ownershipTruncated && (
                <div className="dashboard-ownership-message" role="status">
                  Some ownership details could not be loaded.
                </div>
              )}
              <table className='myTable' border="1" width="99%" cellSpacing="1" cellPadding="2" >
                <thead>
                  <tr align="left" valign="top">
                    <th align="center" valign="middle" width="60" scope="col">Delete</th>
                    <th align="center" valign="middle" width="50" scope="col">SMS</th>
                    <th align="left" valign="middle" scope="col"> &nbsp;Name</th>
                    <th align="center" valign="middle" width="80" scope="col">Rename</th>
                    <th align="center" valign="middle" width="60" scope="col">Unzip</th>
                    <th align="left" valign="middle" width="100" scope="col">&nbsp;Size (Bytes)</th>
                    <th align="left" valign="middle" width="120" scope="col">&nbsp;Last Modified</th>
                    <th align="center" valign="middle" width="80" scope="col">Push Live</th>
                    {isOwnershipEligible && (
                      <>
                        <th align="left" valign="middle" width="140" scope="col">Created By</th>
                        <th align="left" valign="middle" width="140" scope="col">Modified By</th>
                      </>
                    )}
                    {isSuperAdmin && (
                      <th align="center" valign="middle" width="80" scope="col">Index</th>
                    )}

                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan={mainTableColSpan}><Loader /></td></tr>
                  ) : filesLists && filesLists.length > 0 ? (
                      filesLists.map((fileList, index) => {
                        let cellStyle = index % 2 === 0 ? "cellWhite" : "cellGreen";
                        let folderIcon = fileList['isFile'] ? fileIcon : iconFolder;
                        const dir = fileList['directory'];
                        const ownershipKey = buildDashboardOwnershipRowKey(
                          currentPath,
                          { directory: dir, isFile: fileList['isFile'] }
                        );
                        const ownership = ownershipByPath.get(ownershipKey);
                        const formattedOwnership = formatDashboardOwnership(ownership);

                        // Build path for indexing only
                        const pathForIndexing = buildPath(currentPath, dir);
                        const isIndexing = !!indexing[pathForIndexing];

                        return (
                          <tr align="left" valign="top" key={index}>
                            <td width="70" className={"checkboxalign " + cellStyle} >
                              <input
                                type="checkbox"
                                name="fileDelete[]"
                                value={dir}
                                disabled={disableCheckbox}
                                onClick={deleteFiles}
                              />
                            </td>

                            <td width="50" className={"checkboxalign " + cellStyle + " folderpointer"}>
                              <img
                                alt={''}
                                src={(fileList['enable_sms_protection'] === 'Enabled') ? buttonlocked : buttonUnlocked}
                                onClick={() => {
                                  if (!disableCheckbox) { displaySMSPopupModal(dir); }
                                }}
                              />
                            </td>

                            <td className={cellStyle} nowrap="">
                              <div
                                className="folderpointer"
                                onClick={() => rootFolderClickHandler(dir, fileList['isFile'])}
                              >
                                &nbsp;<img alt={''} src={folderIcon} />&nbsp;{dir}
                              </div>
                            </td>

                            <td width="80" className={"folderpointer checkboxalign " + cellStyle}>
                              {!disableCheckbox && (
                                <img alt={''} src={renameButton} onClick={() => displayRenamePopupModal(dir)} />
                              )}
                            </td>

                            <td className={cellStyle}>
                              {fileList['iszip']}
                              {(!disableCheckbox && fileList['iszip'] === true) &&
                                <center>
                                  <img
                                    alt={''}
                                    src={button_unzip}
                                    onClick={() => displayUnzipPopupModal(dir)}
                                    className="folderpointer"
                                  />
                                </center>
                              }
                            </td>

                            <td className={cellStyle}>{fileList['size']}</td>
                            <td className={"checkboxalign " + cellStyle}>{fileList['last_modified_date']}</td>

                            <td className={cellStyle}>
                              {!disableCheckbox &&
                                <center>
                                  <button onClick={() => pushSubmit(dir)} className="formButtonGo">
                                    <img alt={''} src={pushButton} />
                                  </button>
                                </center>
                              }
                            </td>

                            {isOwnershipEligible && (
                              <>
                                <td className={`${cellStyle} dashboard-ownership-cell`}>
                                  {ownershipLoading && !ownership ? (
                                    <span className="dashboard-ownership-loading">
                                      Loading…
                                    </span>
                                  ) : formattedOwnership.created}
                                </td>
                                <td className={`${cellStyle} dashboard-ownership-cell`}>
                                  {ownershipLoading && !ownership ? (
                                  <span className="dashboard-ownership-loading">
                                    Loading…
                                  </span>
                                  ) : formattedOwnership.modified}
                                </td>
                              </>
                            )}

                            {isSuperAdmin && (
                              <td className={cellStyle}>
                                <button
                                  onClick={() => fileindex(pathForIndexing)}
                                  disabled={isIndexing}
                                  title={`Index ${pathForIndexing}`}
                                >
                                  {isIndexing ? 'Indexing...' : 'Index'}
                                </button>
                              </td>
                            )}
                          </tr>
                        );
                      })
                  ) : (
                    <tr>
                      <td colSpan={mainTableColSpan} className="cellWhite">
                        No files or folders in this location.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {!disableCheckbox && (
                <table role="presentation" width="100%">
                  <tbody>
                  {!isVendor && (
                      <>
                    <tr align="left" valign="top">
                      <td align="left">
                        <button className="cellWhite formButtonGo delete-selected" onClick={selectAllFiles}>Select&nbsp;All</button>
                        <span className="cellWhite">&nbsp;|&nbsp;</span>
                        <button className="cellWhite formButtonGo delete-selected" onClick={deSelectAllFiles}>Clear&nbsp;All</button>
                      </td>
                    </tr>
                    <tr align="left" valign="top">
                      <td align="left">
                        <input type="button" value="Delete Selected" className="formButtonStop" onClick={deleteSelectedFiles} />
                        <span className="cellWhite">&nbsp;&nbsp;</span>
                        <input
                          type="button"
                          value="View Deleted Items"
                          className="formButtonStop btn-view-deleted-blue"
                          onClick={() => {
                            deSelectAllFiles(); // Clear current selection
                            setShowDeletedView(true);
                          }}
                        />
                      </td>
                    </tr>
                   </>
                    )}
                    {isVendor && (
                      <tr align="left" valign="top">
                        <td align="left">
                          <input
                            type="button"
                            value="View Deleted Items"
                            className="btn-view-deleted-grey"
                            onClick={() => {
                              deSelectAllFiles(); // Clear current selection
                              setShowDeletedView(true);
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
              </table>
              )}                
            </>
          )}

          <br />

          {isPopupOpen &&
            <Modal
              isOpen={isPopupOpen}
              onRequestClose={closeSMSModalPopup}
              contentLabel="SMS Popup"
              ariaHideApp={false}
              shouldCloseOnOverlayClick={false}
            >
              <SmsPopup
                isOpen={isPopupOpen}
                onRequestClose={closeSMSModalPopup}
                currentPath={currentPath}
                smsFile={selectedFile}
              />
              <Outlet />
            </Modal>
          }

          {showUnzipPopup &&
            <Modal
              isOpen={showUnzipPopup}
              onRequestClose={closeUnzipModalPopup}
              contentLabel="UnZip Popup"
              ariaHideApp={false}
              style={unzipcustomStyles}
              shouldCloseOnOverlayClick={false}
            >
              <Unzip
                isOpen={showUnzipPopup}
                onRequestClose={closeUnzipModalPopup}
                currentPath={currentPath}
                unzipFile={selectedFileToUnzip}
              />
              <Outlet />
            </Modal>
          }

          {noUserDirStatus &&
            <Modal
              isOpen={noUserDirStatus}
              onRequestClose={closeNoUserDirModalPopup}
              contentLabel="No User/Dir Found"
              ariaHideApp={false}
              style={customStyles}
              shouldCloseOnOverlayClick={false}
            >
              <NoUserDir
                isOpen={noUserDirStatus}
                onRequestClose={closeNoUserDirModalPopup}
                data={noUserDirResp}
              />
              <Outlet />
            </Modal>
          }

          {showRenamePopup &&
            <Modal
              isOpen={showRenamePopup}
              onRequestClose={closeRenameFolderModalPopup}
              contentLabel="Rename Folder"
              ariaHideApp={false}
              style={customStyles}
              shouldCloseOnOverlayClick={false}
            >
              <RenameFolder
                isOpen={showRenamePopup}
                onRequestClose={closeRenameFolderModalPopup}
                currentPath={currentPath}
                renamefolder={selectedFileToRename}
              />
              <Outlet />
            </Modal>
          }

          {showDeleteModal &&
            <Modal
              isOpen={showDeleteModal}
              onRequestClose={() => setShowDeleteModal(false)}
              contentLabel="Delete Confirmation"
              ariaHideApp={false}
              style={customStyles}
              shouldCloseOnOverlayClick={false}
            >
              <DeleteFolder
                showDeleteModal={showDeleteModal}
                setShowDeleteModal={setShowDeleteModal}
                filesToDelete={filesToDelete}
                currentPath={currentPath}
                confirmDelete={confirmDelete}
              />
              <Outlet />
            </Modal>
          }

          {showRestoreModal &&
            <Modal
              isOpen={showRestoreModal}
              onRequestClose={() => setShowRestoreModal(false)}
              contentLabel="Restore Confirmation"
              ariaHideApp={false}
              style={customStyles}
              shouldCloseOnOverlayClick={false}
            >
              <RestoreItemsModal
                setShowRestoreModal={setShowRestoreModal}
                itemsToRestore={deletedItemsToRestore}
                currentPath={currentPath}
                confirmRestore={confirmRestore}
              />
              <Outlet />
            </Modal>
          }

        </div>
        <Footer />
      </body>
    </>
  );
};

export default Dashboard;
